import { Layout } from "antd";
import packageJson from '../../../package.json';
import { getAppVersion } from '../../store/actions/CommonActions';
import { useState, useEffect } from "react";
import { formatDictString, getTranslated } from "../../utils/CommonUtils";
import { useSelector } from "react-redux";

const UMCFooter = () => {

    const [appVersion, setAppVersion] = useState(packageJson.version)
    const dict = useSelector(state => state.common.dict)

    useEffect(() => {
        getAppVersion((version) => {
            if (version) {
                console.log('App version from req:', version)
                setAppVersion(version)
            }
        });
    }, []);

    return <Layout.Footer>
        <div id="mainFooter">
            <p id="footerTerms">
                &copy; 2025 ALE International
                {" | "}
                <a href="/Terms-and-conditions-UMC.pdf" target="_blank" rel="noopener noreferrer">
                    {getTranslated(dict, "LABEL_TERMS_CONDITION")}
                </a>
                {" | "}
                <button type="button" onClick={() => window.OneTrust.ToggleInfoDisplay()}>
                    {getTranslated(dict, "MSG_COOKIE")}
                </button>
                {" | "}
                {formatDictString(dict, "LABEL_SW_LICENSE_VERSION", { appVersion: appVersion })}
            </p>

            <p id="footerContact">
                <a href="https://myportal.al-enterprise.com/s/contact-us" target="_blank" rel="noopener noreferrer">
                    {getTranslated(dict, "LABEL_CONTACT_ALE")}
                </a>
            </p>
        </div>
    </Layout.Footer>
}

export default UMCFooter
